import React from 'react';
import { object } from 'prop-types';
import { EditIcon } from 'components/Icons';

function Edit({ row, handlers }) {
    return <EditIcon onClick={() => handlers.handleEditClient({ row })} />;
}

Edit.propTypes = {
    row: object,
    handlers: object,
};

Edit.defaultProps = {
    row: {},
    handlers: { handleEditClient: () => {} },
};

export default Edit;
